import React, { useState, useEffect, useCallback } from 'react';
import { heroData } from '../data/mockData';

const VineOrnament = ({ mirrored = false }) => (
  <svg
    width="220"
    height="80"
    viewBox="0 0 220 80"
    className="hidden md:block"
    fill="none"
    style={mirrored ? { transform: 'scaleX(-1)' } : undefined}
  >
    <path
      d="M220,42 C200,38 182,30 162,34 C142,38 122,48 102,44 C82,40 62,31 42,35 C22,39 8,43 0,41"
      stroke="#fff" strokeWidth="1.2" fill="none" opacity="0.6"
    />
    <path d="M155,34 C158,26 163,19 169,14" stroke="#fff" strokeWidth="0.7" fill="none" opacity="0.4" />
    <path d="M170,36 C174,44 178,52 181,58" stroke="#fff" strokeWidth="0.7" fill="none" opacity="0.4" />
    <ellipse cx="178" cy="22" rx="5" ry="9" fill="#fff" opacity="0.2" transform="rotate(-30 178 22)" />
    <ellipse cx="140" cy="50" rx="5" ry="9" fill="#fff" opacity="0.25" transform="rotate(20 140 50)" />
    <ellipse cx="88" cy="37" rx="5" ry="9" fill="#fff" opacity="0.2" transform="rotate(-15 88 37)" />
    <ellipse cx="42" cy="28" rx="5" ry="9" fill="#fff" opacity="0.2" transform="rotate(25 42 28)" />
    <circle cx="104" cy="38" r="1.4" fill="#fff" opacity="0.35" />
    <circle cx="108" cy="34" r="1.3" fill="#fff" opacity="0.35" />
    <circle cx="112" cy="39" r="1.4" fill="#fff" opacity="0.3" />
    <circle cx="107" cy="42" r="1.2" fill="#fff" opacity="0.3" />
    <circle cx="101" cy="33" r="1.2" fill="#fff" opacity="0.28" />
    <circle cx="114" cy="35" r="1.2" fill="#fff" opacity="0.25" />
  </svg>
);

const HeroSection = () => {
  const [currentSlide, setCurrentSlide] = useState(0);
  const images = heroData.heroImages;

  const nextSlide = useCallback(() => {
    setCurrentSlide((prev) => (prev + 1) % images.length);
  }, [images.length]);

  useEffect(() => {
    const interval = setInterval(nextSlide, 5000);
    return () => clearInterval(interval);
  }, [nextSlide]);

  return (
    <section id="home" className="relative pt-[60px] md:pt-[72px]">
      {/* Hero Image Slider */}
      <div className="relative w-full h-[40vh] sm:h-[50vh] md:h-[85vh] lg:h-[95vh] overflow-hidden">
        {images.map((img, index) => (
          <div
            key={index}
            className={`absolute inset-0 transition-opacity duration-1000 ${
              index === currentSlide ? 'opacity-100' : 'opacity-0'
            }`}
          >
            <img
              src={img}
              alt={`Wedding slide ${index + 1}`}
              className="w-full h-full object-cover object-top"
            />
          </div>
        ))}

        {/* Dark overlay for text readability */}
        <div className="absolute inset-0 bg-black/30" />

        {/* Names and Date — overlaying the hero image */}
        <div className="absolute inset-0 flex items-center justify-center z-10">
          <div className="text-center px-4 animate-hero-emerge">
            <div className="flex items-center justify-center gap-3 md:gap-6 mb-4">
              <VineOrnament />
              <h1 className="font-script text-5xl md:text-7xl lg:text-[90px] text-white leading-none drop-shadow-lg">
                {heroData.brideName} & {heroData.groomName}
              </h1>
              <VineOrnament mirrored />
            </div>
            <p className="font-body text-base md:text-lg text-white/85 tracking-[0.2em] mt-2 drop-shadow-md">
              {heroData.tagline} {heroData.weddingDate}
            </p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default HeroSection;
